// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { DistrictName, DistrictNameSchema } from 'api/gen/DistrictName';

const requiredPart = t.interface({
  code: t.Integer,
  internalCode: t.union([t.Integer, t.null]),
  name: DistrictNameSchema,
});

export const CabDistrictAutocompleteSchema = excess(requiredPart);

export interface CabDistrictAutocomplete extends t.TypeOf<typeof CabDistrictAutocompleteSchema> {}
